import DashboardGraph from "../dashboard/dashboard.graph.service";
import { HtmlHeader, HtmlLink } from '../html-elements/module';
var Grid = /** @class */ (function () {
    function Grid(main, data, element, mapping, segment) {
        this.main = main;
        this.data = data;
        this.element = element;
        this.mapping = mapping;
        this.segment = segment;
        this.graphService = new DashboardGraph(this.main);
    }
    Grid.prototype.pre = function () {
    };
    Grid.prototype.init = function () {
        // create 
        var _this = this;
        if (this.mapping.header) {
            this.htmlHeader = new HtmlHeader(this.element, this.mapping.header);
            this.htmlHeader.draw();
            this.htmlHeader.hide();
        }
        var section = document.createElement('section');
        section.classList.add("img-graph-grid-container");
        this.element.appendChild(section);
        // console.log(section);
        this.graphService.call('', this.mapping.children, this.segment, false, section);
        if (this.mapping.linkTopic) {
            this.htmlLink = new HtmlLink(this.main, this.element, this.mapping.linkLabel, this.mapping.linkTopic);
            this.htmlLink.draw();
            this.htmlLink.hide();
        }
        setTimeout(function () {
            _this.htmlHeader.show();
            if (_this.mapping.linkTopic) {
                _this.htmlLink.show();
            }
        }, 1000);
    };
    Grid.prototype.prepareData = function (data) {
    };
    Grid.prototype.redraw = function (data) {
    };
    Grid.prototype.update = function (data, segment, update) {
    };
    return Grid;
}());
export default Grid;
